<div class="dx-card wide-card">
    <h4 class="content-block ap-green">Pipeline Connections</h4>
    <div class="content-block">
        <dx-responsive-box singleColumnScreen="sm" [(screenByWidth)]="screen">
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-col [ratio]="1"></dxi-col>
            <dxi-col [ratio]="1" screen="lg"></dxi-col>
            <dxi-col [ratio]="1"></dxi-col>
            <dxi-item class="marginB10">
                <dxi-location screen="md lg" [row]="0" [col]="0"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label">Material</div>
                    <div class="dx-field-value">
                        <dx-select-box [searchMode]="searchModeOption" [searchEnabled]="true"
                        [searchExpr]="searchExprOption" [(value)]="materialId"
                            (onValueChanged)="onMaterialChange($event)" displayExpr="materialName"
                            valueExpr="materialId" [(dataSource)]="materials"></dx-select-box>
                    </div>
                </div>
            </dxi-item>
        </dx-responsive-box>
    </div>
    <dx-data-grid class="fixGridHeight" id="PipelinesGrid" [dataSource]="pipelines" [showBorders]="true"
        (onInitNewRow)="onInitNewRow($event)" (onRowInserted)="addPipeline($event)"
        (onRowUpdated)="updatePipeline($event)" (onEditorPreparing)="onEditorPreparing($event)" *ngIf="showGrid"
        [allowColumnResizing]="true" [rowAlternationEnabled]="true" [showRowLines]="true" [showColumnLines]="true"
        [showBorders]="true" keyExpr="pipelineId">
        <dxo-filter-row [visible]="false"></dxo-filter-row>
        <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-search-panel [visible]="true" [text]="selectedPipeline"></dxo-search-panel>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-editing mode="popup" [useIcons]="true" [allowUpdating]="true" [allowAdding]="true">
            <dxo-popup title="Add/Edit a Pipeline" [showTitle]="true" [toolbarItems]="[  
            {  
            widget: 'dxButton',  
            location: 'after',  
            options: {  
              text: 'Save',  
              icon: '',
              stylingMode:'contained',
              type:'success'
            },  
            toolbar: 'bottom',  
            onClick: onSaveClick  
        },{  
            widget: 'dxButton',  
            location: 'after',  
            options: {  
              text: 'Cancel',  
              type: 'danger',
              icon: ''  
            },  
            toolbar: 'bottom',  
            onClick: onCancelClick  
        }]">
            </dxo-popup>
        </dxo-editing>

        <dxo-toolbar>
            <dxi-item name="groupPanel"></dxi-item>
            <dxi-item location="after">
                <dx-button (onClick)="addRow()" stylingMode="contained" type="default" text="Add New Pipeline"></dx-button>
                <dx-button text="Reset" stylingMode="contained" type="default" (onClick)="resetFilters()">
                </dx-button>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>
        <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
            [showInfo]="true" [showNavigationButtons]="false"></dxo-pager>
        <dxi-column type="buttons" [width]="110">
            <dxi-button name="edit"></dxi-button>
            <dxi-button name="delete"></dxi-button>
        </dxi-column>
        <dxi-column dataField="pipelineCode" dataType="string" caption="Pipeline Code"
            [setCellValue]="setPipelineCodeValue" editCellTemplate="editPipelineCodeTemplate">
        </dxi-column>
        <div *dxTemplate="let cellInfo of 'editPipelineCodeTemplate'">
            <b
                *ngIf="!cellInfo.data.city">{{cellInfo.data.supplier}}-{{cellInfo.data.country}}-{{cellInfo.data.stateProvince}}</b>
            <b
                *ngIf="cellInfo.data.city">{{cellInfo.data.supplier}}-{{cellInfo.data.country}}-{{cellInfo.data.stateProvince}}-{{cellInfo.data.city}}</b>
            <!-- <dxo-label [height]="90" (onValueChanged)="cellInfo.setValue($event.value)" [value)]="cellInfo.value"></dxo-label> -->

        </div>
        <dxi-column dataField="supplier" [visible]="false" caption="Supplier (Please don't use dash(-) in Supplier name)" [editorOptions]="supplierColumnOptions"
            [setCellValue]="setSupplierValue">
            <dxi-validation-rule type="required"></dxi-validation-rule>
            <dxo-lookup [dataSource]="suppliers" displayExpr="supplierName" valueExpr="supplierName">
            </dxo-lookup>
        </dxi-column>
        <dxi-column dataField="country" [setCellValue]="setCountryValue" [visible]="false">
            <dxi-validation-rule type="required"></dxi-validation-rule>
            <dxo-lookup [dataSource]="countries" (onValueChanged)="onSelectionChanged($event)" displayExpr="countryName"
                valueExpr="countryName">
            </dxo-lookup>
        </dxi-column>
        <dxi-column dataField="stateProvince" [setCellValue]="setStateValue" [visible]="false">
            <dxi-validation-rule type="required"></dxi-validation-rule>
            <dxo-lookup [dataSource]="getFilteredStates" displayExpr="province" valueExpr="province">
            </dxo-lookup>
        </dxi-column>
        <dxi-column dataField="city" [visible]="false" caption="City/Other (Please don't use dash(-))" [setCellValue]="setCityValue"></dxi-column>
        <dxi-column dataField="materialId" [visible]="false" caption="Material">
            <dxo-lookup [dataSource]="materials" displayExpr="materialName" valueExpr="materialId">
            </dxo-lookup>
        </dxi-column>

        <dxi-column dataField="multiCustomerPipeline" dataType="boolean" [visible]="false"></dxi-column>
        <dxi-column dataField="isActive" dataType="boolean" caption="Active"></dxi-column>
        <dxi-column dataField="pipelineNotes" [visible]="false" editCellTemplate="editTextTemplate"></dxi-column>

        <dxo-master-detail [enabled]="true" template="supplierConnections"></dxo-master-detail>
        <div *dxTemplate="let supplierConnection of 'supplierConnections'">
            <supplier-connection (setLoadPanelVisibility)="setLoadPanelVisibility($event)"
                [pipelineId]="supplierConnection.key" [materialName]="materialName" [pipelineCode]="supplierConnection.data.pipelineCode" [materialId]="materialId" [sites]="sites" [uoms]="uoms">
            </supplier-connection>
            <div style="margin-top: 10px;"></div>
            <customer-connection (setLoadPanelVisibility)="setLoadPanelVisibility($event)"
                [pipelineId]="supplierConnection.key" [materialName]="materialName" [pipelineCode]="supplierConnection.data.pipelineCode" [materialId]="materialId" [sites]="sites" [uoms]="uoms">
            </customer-connection>
        </div>
        <div *dxTemplate="let cellInfo of 'editTextTemplate'">
            <dx-text-area [height]="90" (onValueChanged)="cellInfo.setValue($event.value)" [(value)]="cellInfo.value">
            </dx-text-area>
        </div>
    </dx-data-grid>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>